<template src="./index.html"></template>
<script>
import data from './data.js';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import uploadFile from '../uploadFile/index.vue';
import { zcfg_fycx, zcfg_zcxz, zcfg_upload, zcfg_deletescwj, policypage, update, tagdelete, tagsave } from '../../../api/zcfg.js';
import { getdata } from '../../page/DataAcquisition/customs/billdetails/data.js';

export default {
    name: '',
    components: {
        quillEditor,
        uploadFile
    },
    props: {
        zcdiag: {
            type: Boolean,
            default: false
        },
        //用于判断是哪个界面
        wikiType: {
            type: String,
            default: ''
        },
        //form表单数据
        formdata: {
            type: Object,
            default: {
                isValid: '1',
                policyType: '1'
            }
        },
        //政策
        zclist: {
            type: Object,
            default: []
        },
        //文件
        upformdataadd: {
            type: Array,
            default: []
        },
        //原文件链接、文本框数据
        fbkyuwduixi: {
            type: Object,
            default: {
                originalLink: '',
                content: ''
            }
        }
    },
    watch: {
        zcdiag: function (indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {
                    console.log(this.formdata);
                    this.policypage();
                    this.$refs.taxform.clearValidate();
                });
                // this.originalLink = this.chuanoriginalLink;
                // this.content = this.chuancontent;
            }
        }
    },
    data: function () {
        return {
            formlist: data.formlist,
            // formdata: data.formdata,
            pagination: data.pagination,
            editorOption: {
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike', 'link', 'image', 'code-block'], // toggled buttons
                        [
                            {
                                align: []
                            }
                        ], //对齐方式
                        [
                            {
                                header: [1, 2, 3, 4, 5, 6, false]
                            }
                        ], //几级标题
                        [
                            {
                                font: []
                            }
                        ], //字体
                        [
                            {
                                size: ['small', 'normal', 'large', 'huge']
                            }
                        ],
                        [
                            {
                                color: []
                            },
                            {
                                background: []
                            }
                        ] // 字体颜色，字体背景颜色
                    ]
                }
            },
            upfilediag: false,
            addzcdiag: false,
            searchdatazc: {},
            searchlistzc: data.searchlistzc,
            headDatazc: data.headDatazc,
            tableDatazc: [],
            upformdata: {}, //文件信息
            policyFileList: [], //上传文件返回id
            suoming: '', //说明
            originalLink: '',
            content: '',
            options: [],
            CustomType: false,
            headDatatagId: data.headDatatagId,
            tableDatatagId: [],
            updataItem: []
        };
    },
    created() {},
    methods: {
        addtagId() {
            this.tableDatatagId.push({
                updata: true,
                add: true,
                tagName: ''
            });
            this.tableDatatagId = JSON.parse(JSON.stringify(this.tableDatatagId));
            this.updataItem = this.tableDatatagId[this.tableDatatagId.length - 1];
        },
        removes(e) {
            let params = {
                id: e.id
            };
            tagdelete(params).then((res) => {
                if (res.data.code == 1) {
                    this.policypage();
                    this.formdata.tagIds.map((item, index) => {
                        if (item == e.id) {
                            this.formdata.tagIds.splice(index, 1);
                        }
                    });
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        cancellation(e, index) {
            if (e.add) {
                this.tableDatatagId.splice(index, 1);
                this.tableDatatagId = JSON.parse(JSON.stringify(this.tableDatatagId));
            } else {
                e.updata = false;
            }
        },
        updata(e) {
            for (let a = 0; a < this.tableDatatagId.length; a++) {
                if (this.tableDatatagId[a].updata) {
                    return this.$message.error('存在未保存（取消）的数据，请保存（取消）后再编辑');
                }
            }
            e.updata = true;
            this.updataItem = JSON.parse(JSON.stringify(e));
            this.tableDatatagId = JSON.parse(JSON.stringify(this.tableDatatagId));
        },
        save(e) {
            if (e.add) {
                tagsave(e).then((res) => {
                    if (res.data.code == 1) {
                        this.policypage();
                        this.$emit('policypage','')
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            } else {
                update(this.updataItem).then((res) => {
                    if (res.data.code == 1) {
                        this.policypage();
                        this.$emit('policypage','')
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            }
        },
        policypage() {
            let params = {
                size: 100000000
            };
            policypage(params).then((res) => {
                if (res.data.code == 1) {
                    this.tableDatatagId = res.data.data.records;
                    this.tableDatatagId.map((item) => {
                        item.updata = false;
                    });
                    this.options = res.data.data.records.map((item) => {
                        return {
                            label: item.tagName,
                            value: item.id
                        };
                    });
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        getdata(e) {},
        upfilediagff() {
            //相关文件弹框
            this.upfilediag = true;
            this.suoming = '';
            this.$refs['uploadfileRef'].forrefresh();
        },
        Custom() {
            this.$refs.configSelect.blur();
            this.CustomType = true;
        },
        // 获取到的文件信息
        getuploadparams(e) {
            this.upformdata = e;
        },
        addzcdiagff() {
            this.searchdatazc = { policyTitle: '', policyType: '', isValid: '' };
            this.fetchResultShow();
            this.addzcdiag = true;
        },
        // 查询进行发票合计结果(分页)
        fetchResultShow() {
            let nowId = this.formdata.id;
            let params = JSON.parse(JSON.stringify(this.searchdatazc));
            params.current = this.pagination.pageNum;
            params.size = this.pagination.pageSize;
            params.sort = '';
            params.order = '';
            params.filterIds = this.zclist.map((v) => v.id).join(',');
            if (nowId) {
                params.filterIds = params.filterIds + ',' + nowId;
            }
            // params.search = ;
            zcfg_fycx(params).then((res) => {
                this.pagination.total = res.data.data.total;
                this.tableDatazc = res.data.data.records;
            });
        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.fetchResultShow();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.fetchResultShow();
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.fetchResultShow();
        },
        quxiao() {
            this.upfilediag = false;
        },
        upfj() {
            if (Object.values(this.upformdata).length > 0) {
                this.upformdata.suoming = this.suoming;
                let formData = {
                    desc: this.upformdata.suoming,
                    uploadFile: this.upformdata.upfile
                };
                zcfg_upload(formData).then((res) => {
                    if (res.data.code != 1) {
                        this.$message.error(this.upformdata.upfilename + '文件上传失败！' + res.data.msg);
                    } else {
                        let newObj = JSON.parse(JSON.stringify(this.upformdata));
                        newObj.policyFileList = res.data.data;
                        let newarr = JSON.parse(JSON.stringify(this.upformdataadd));
                        newarr.push(newObj);
                        this.$emit('changeUpformdataadd', newarr);
                    }
                });
                this.upfilediag = false;
            } else {
                this.$message.error('请选择文件！');
            }
        },

        addzc() {
            var chooseitem = this.$refs.tablebox.getSelectionval();
            chooseitem.forEach((v) => {
                this.zclist.push(v);
            });
            this.addzcdiag = false;
        },
        closediag() {
            this.$emit('closediag', false);
        },
        spliceywfdiag(index) {
            this.zclist.splice(index, 1);
        },
        spliceywfdiagwj(index) {
            let params = {
                id: this.upformdataadd[index].policyFileList
            };
            zcfg_deletescwj(params).then((res) => {
                if (res.data.code == 1) {
                    this.upformdataadd.splice(index, 1);
                } else {
                    this.$message.error('取消失败！' + res.data.msg);
                }
            });
        },

        addxz() {
            this.$refs.taxform.submitForm();
            if (this.formdata.policyTitle == '') {
                return;
            }
            this.formdata.originalLink = this.fbkyuwduixi.originalLink;
            this.formdata.policyDesc = this.fbkyuwduixi.content;
            // let list = new Array(this.upformdataadd.length);
            // this.upformdataadd.forEach((v, k) => {
            //   list[k] = v.policyFileList;
            // });
            this.formdata.policyFileList = this.upformdataadd.map((item) => item.policyFileList);

            // let zcjd = new Array(this.zclist.length);
            // this.zclist.forEach((v, k) => {
            //   zcjd[k] = v.id;
            // });
            this.formdata.policyList = this.zclist.map((item) => item.id);
            this.formdata.wikiType = this.wikiType;
            this.formdata.tagIds.map((item, index) => {
                if (!item) {
                    this.formdata.tagIds.splice(index, 1);
                }
            });
            console.log(this.formdata);
            zcfg_zcxz(this.formdata).then((res) => {
                if (res.data.code == 1) {
                    this.$message.success('保存成功');
                    this.$emit('fzchuan', true);
                } else {
                    this.$message.error('保存失败！' + res.data.msg);
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
